<template>
  <Layout class="app_layout">
    <Sider breakpoint="md" collapsible :collapsed-width="78">
      <div class="app_logo">Neuron</div>
      <Menu
        :open-names="openNames"
        :active-name="menuActiveName"
        width="auto"
        :class="menuitemClasses"
        @on-select="handleNext"
        ref="childMenu"
      >
        <Submenu name="Application">
          <template slot="title">
            <Icon type="ios-paper" />
            Application
          </template>
          <MenuItem name="Application">Application List</MenuItem>
        </Submenu>
        <Submenu name="Deployment">
          <template slot="title">
            <Icon type="ios-paper" />
            Account config
          </template>
          <MenuItem name="Deployment">Deployment</MenuItem>
        </Submenu>
      </Menu>
      <div slot="trigger"></div>
    </Sider>
    <Layout class="app_content">
      <Header theme="light" class="layout_header_bar">
        <Breadcrumb>
          <!-- <BreadcrumbItem
            to="/Application"
            :class="$route.path==='/Application' ? 'spc' : ''"
          >
            Home
          </BreadcrumbItem> -->
          <BreadcrumbItem
            v-for="item in crumbList"
            :key="item.name"
            :to="item.path"
            :class="$route.name === item.name ? 'spc' : ''"
          >
            {{ item.name }}
            <!-- <Icon type="ios-close-circle" class="BreadcrumbItemIcon" @click="handleClose(item)"/> -->
          </BreadcrumbItem>
        </Breadcrumb>
        <Dropdown trigger="click" @on-click="headerDropdown">
          <Avatar
            :src="fileSrc"
            icon="ios-person"
            style="margin-right: 10px"
          ></Avatar>
          <a href="javascript:void(0)">
            {{ userName }}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="logout">Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Header>
      <Content>
        <router-view />
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "home",
  data() {
    return {
      userName: "Admin",
      theme: "default",
      isCollapsed: false,
      fileSrc: "",
      currentName: "",
      BreadList: [],
      openNames: ["Application"],
    };
  },
  computed: {
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    ...mapState(["crumbList", "menuActiveName"]),
    ...mapGetters({
      userInfo: "app/getUserInfo",
      token: "app/getToken",
    }),
  },
  watch: {
    crumbList: {
      handler(newName) {
        this.watchRoute(newName);
      },
    },
  },
  created() {
    this.init();
    this.changeTheme();
    this.setToken();
    this.openNames = [this.menuActiveName];
  },
  mounted() {
    let str = JSON.parse(JSON.stringify(this.$route.path));
    str = str.substring(1);
    if (str === "Application") return;
    const obj = {
      id: str,
      name: str,
    };
    this.BreadList.push(obj);
  },
  methods: {
    watchRoute(list) {
      const arr = [];
      list.forEach((item) => {
        arr.push(item.name);
      });
      this.openNames = arr;
      this.$nextTick(() => {
        this.$refs.childMenu.updateActiveName();
        this.$refs.childMenu.updateOpened();
      });
    },
    // 左侧路由菜单跳转
    handleNext(name) {
      this.currentName = name;
      this.$router.push({
        path: `/${name}`,
      });
      const crumb = {
        crumbList: this.crumbList,
        name,
      };
      this.$store.commit("updateCrumbList", crumb); // 更新list
    },
    // // 关闭标签页
    // handleClose(item) {
    //   // console.log(item.name);
    //   const crumbArr = this.crumbList;
    //   // let obj = {};
    //   crumbArr.forEach((it, i) => {
    //     if (it.name === item.name) {
    //       // obj = crumbArr[i - 1];
    //       crumbArr.splice(i, 1);
    //     }
    //   });
    //   this.$store.commit("updateCrumbList", crumbArr);
    //   // console.log(crumbArr, "02121");
    // },
    // 动态路由类名
    handleClass() {
      return "asc";
    },
    init() {
      this.userName = this.userInfo.username;
      if (this.userInfo.picture) {
        setTimeout(() => {
          this.getFileFun(this.userInfo.picture);
        }, 100);
      }
    },
    getFileFun(key) {
      console.log(window);
      window.AWS_S3_FUNCTIONS.GET_IMG_FILE(key)
        .then((res) => {
          // // console.log(res);
          if (res.isSuccess) {
            this.fileSrc = res.data;
          } else {
            this.fileSrc = "";
          }
        })
        .catch((e) => {
          this.$Message.error(e.err.message);
          // // console.log(e);
        });
    },
    headerDropdown(name) {
      // // console.log(name, "46464");
      switch (name) {
        case "logout":
          this.$router.push({
            path: "/",
          });
          break;

        default:
          break;
      }
    },

    changeTheme() {
      const query = this.$route.query.theme;
      if (query) {
        document.body.id = query;
      } else {
        document.body.id = this.theme;
      }
    },
    setToken() {
      const { query } = this.$route;
      if (query && query.token) {
        const token = query.token || this.token;
        const userInfo = JSON.parse(query.userInfo || this.userInfo);
        const { username } = userInfo;
        // sessionStorage.setItem("token", token);
        this.$store.dispatch("app/updateParams", { token });
        this.$store.dispatch("app/updateParams", { username });
        this.$store.dispatch("app/updateParams", query.userInfo);
        // sessionStorage.setItem("username", userInfo.username);
        // sessionStorage.setItem("userInfo", query.userInfo);
      }
      this.init();
    },
  },
};
</script>

<style lang="less">
.app_layout {
  height: 100%;
  .layout_header_bar {
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .ivu-layout-sider {
    margin-right: 16px;
  }
  .ivu-layout-sider.ivu-layout-sider-zero-width.ivu-layout-sider-collapsed {
    margin-right: 0;
  }
  .app_logo {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ivu-layout-sider {
    height: 100%;
    overflow: auto;
    background: #fff;
  }
  .app_content {
    background: transparent;
    .ivu-layout-content {
      height: calc(100vh - 64px - 16px);
      overflow: auto;
      margin-top: 16px;
    }
  }
  .ivu-breadcrumb span a {
    font-weight: normal;
  }
  .spc a {
    color: #515a6e;
    font-weight: bold !important;
  }
  .ivu-breadcrumb .BreadcrumbItemIcon {
    display: none;
    position: relative;
    top: -8px;
    left: -3px;
    cursor: pointer;
  }
  .ivu-breadcrumb {
    span {
      &:hover {
        .BreadcrumbItemIcon {
          display: inline-block;
        }
      }
    }
  }
}
</style>
